import React from 'react';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Opened",
        value: "1"
    },
    {
        text: "Completed",
        value: "2"
    },
    {
        text: "Cancelled",
        value: "3"
    },
    {
        text: "Returned",
        value: "4"
    },
    {
        text: "ReturnedPartial",
        value: "5"
    },
    {
        text: "Reopened",
        value: "6"
    },
    {
        text: "ManuallyDiscounted",
        value: "11"
    }
];


const searchFields = (props) => {
    return (
        <div className="row m-0">
            {/*Search Inputs*/}
            <div className="row m-0">
                <div className="col-sm-4">
                    <TextInput
                        type="number"
                        name={`${props.pageName}OrderNumberFilter`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orders.orderNumber.label}
                        floatingLabelText={LOOKUP.menu.admin.orders.orderNumber.label}
                        hintText={LOOKUP.menu.admin.orders.orderNumber.hintText}
                        maxLength={20}
                        onPressKey={props.search} />
                </div>
                <div className="col-sm-4">
                    <DatePickerInput name={`${props.pageName}StartDate`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orders.dateStart.label}
                        floatingLabelText={LOOKUP.menu.admin.orders.dateStart.label}
                        hintText={LOOKUP.menu.admin.orders.dateStart.hintText}
                    />
                </div>
                <div className="col-sm-4">
                    <DatePickerInput name={`${props.pageName}EndDate`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orders.dateEnd.label}
                        floatingLabelText={LOOKUP.menu.admin.orders.dateEnd.label}
                        hintText={LOOKUP.menu.admin.orders.dateEnd.hintText}
                    />
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-4">
                    <SelectInput name={`${props.pageName}EmployeeId`}
                        className="search-field"
                        label={LOOKUP.shiftList.filters.employee.label}
                        floatingLabelText={LOOKUP.shiftList.filters.employee.label}
                        hintText={LOOKUP.shiftList.filters.employee.label}
                        options={props.employeeOptions}
                    />
                </div>
                <div className="col-sm-4">
                    <SelectInput name={`${props.pageName}Status`}
                        className="search-field"
                        label={LOOKUP.menu.admin.orders.orderStatus.label}
                        floatingLabelText={LOOKUP.menu.admin.orders.orderStatus.label}
                        hintText={LOOKUP.menu.admin.orders.orderStatus.hintText}
                        options={statusOptions}
                    />
                </div>
                <div className="col-sm-4">
                    <TextInput
                        name={`${props.pageName}FirstNameFilter`}
                        className="search-field"
                        label={"Recipient First Name"}
                        floatingLabelText={"Recipient First Name"}
                        hintText={"Recipient First Name"}
                        maxLength={20}
                        onPressKey={props.search} />
                </div>
            </div>
            {/*Buttons*/}
            <div className="row m-0 mt-2 search-buttons">
                <div className="col-lg-12 text-right">
                    <Button
                        type="IconSearchButton"
                        mini={true}
                        label={LOOKUP.patient.filters.filterButton}
                        onTouchTap={() => props.search()}
                        className="btnNewBrandPOS"
                    />
                    <Button
                        className="ml-1 btnCleanSearch"
                        type="IconClearButton"
                        label={LOOKUP.patient.filters.cleanFilterButton}
                        onTouchTap={() => props.cleanSearch()}
                    />
                </div>
            </div>
        </div>
    );
};


export default searchFields;
